import { useEffect } from 'react';
import { setTokenGetter, setTokenRefresher } from '@y-sports/api-client';
import { useKeycloak } from '@y-sports/shared/auth';

export function useApiClientAuthentication() {
  const { keycloak } = useKeycloak();

  useEffect(() => {
    setTokenGetter(() => keycloak.token || null);
    setTokenRefresher(async () => {
      try {
        await keycloak.updateToken(5);
        return keycloak.token || null;
      } catch (error) {
        console.error('Token refresh failed:', error);
        void keycloak.logout();
        return null;
      }
    });
  }, [keycloak]);
}

